export default [
  {
    modulId: "vemaKonzept",
    modulPrefix: "",
    anzeigen: false,
    aktiv: true,
    inaktivText: "(Nur in Kombination mit Premium abschließbar)",
    preisId: "",
    name: "",
    nameMakler: "VEMA-Konzept",
    icon: "vema-konzept",
    info:
      "Das VEMA-Konzept erweitert bzw. ergänzt die folgenden Leistungen:" +
      "<ul>" +
      "<li>Schlossänderungskosten bei einfachem Diebstahl von Schlüsseln</li>" +
      "<li>Handelsware oder Musterkollektionen: 30.000 €</li>" +
      "<li>Plansch- und Reinigungswasser: 10.000 €</li>" +
      "<li>Versicherte Kosten über VS hinaus: 100 % der VS</li>" +
      "<li>Mehrkosten über Neuwert für ressourcenschonende Reparaturen: 100 %</li>" +
      "<li>24-Std.-Diebstahl-Schutz von nicht versicherungspflichtigen Fahrrädern, Dreirädern, Fahrradanhängern, E-Bikes und Pedelecs sowie deren Zubehör (optional erweiterbar): 10.000 €</li>" +
      "<li>Trickdiebstahl außerhalb des Versicherungsortes: 10.000 €</li>" +
      "<li>Opfer einer polizeilich angezeigten Straftat: 10.000 €</li>" +
      "<li>Beschädigung und Abhandenkommen von Sachen auf Reisen: 3.000 € (200 € SB)</li>" +
      "<li>Schäden durch Tiere: 3.000 € (200 € SB)</li>" +
      "</ul>",
    infoMakler: "",
    body:
      '<ul class="c-list">' +
      '<li class="c-list__item">Mehrkosten über Neuwert für ressourcenschonende Reparaturen: 100 %</li>' +
      '<li class="c-list__item">24-Std.-Diebstahl-Schutz von nicht versicherungspflichtigen Fahrrädern, Dreirädern, Fahrradanhängern, E-Bikes und Pedelecs sowie deren Zubehör (optional erweiterbar): 10.000 €</li>' +
      '<li class="c-list__item">Opfer einer polizeilich angezeigten Straftat: 10.000 €</li>' +
      '<li class="c-list__item">Beschädigung und Abhandenkommen von Sachen auf Reisen: 3.000 € (200 € SB)</li>' +
      "</ul>",
  },
  {
    modulId: "glasschutz",
    modulPrefix: "",
    anzeigen: true,
    aktiv: true,
    inaktivText: "",
    preisId: "VHV2024_GLASBRUCH",
    name: "Glasbruch",
    nameMakler: "Glasbruch",
    icon: "icon-glass-protect",
    info:
      "Ergänzen Sie Ihren Schutz um Glasbruchschäden an:" +
      "<ul>" +
      "<li>Gesamte Gebäudeverglasung (ohne Laden- und Schaufensterscheiben)</li>" +
      "<li>Mobiliarverglasung (in den vom Versicherungsnehmer selbst bewohnten Räumen)</li>" +
      "</ul>",
    body:
      '<div class="o-grid__cell o-grid__cell--9">' +
      '<ul class="c-list">' +
      '<li class="c-list__item">Gebäudeverglasung</li>' +
      '<li class="c-list__item">Mobiliarverglasung</li>' +
      "</ul>" +
      "</div>",
  },
  {
    modulId: "elementar",
    modulPrefix: "",
    anzeigen: true,
    aktiv: true,
    inaktivText: "",
    preisId: "VHV2024_ELEMENTAR",
    name: "Naturgewalten Elementar",
    nameMakler: "Naturgewalten Elementar",
    icon: "icon-water-sun",
    info:
      "Erweitert den bereits enthaltenen Sturm- und Hagel-Schutz um folgende Naturgewalten:" +
      "<ul>" +
      "<li>Überschwemmung aufgrund Starkregen</li>" +
      "<li>Erdbeben, Erdsenkung, Erdrutsch</li>" +
      "<li>Schneedruck, Lawinen</li>" +
      "<li>Vulkanausbruch</li>" +
      "</ul>" +
      "Die Selbstbeteiligung beträgt je Schadenfall 10% des Schadens - mindestens 500 €, maximal 5.000 €. Für einige Wohngebiete in Deutschland bieten wir nur eine Teilabsicherung an.",
    body:
      '<div class="o-grid__cell o-grid__cell--9">' +
      '<ul class="c-list">' +
      '<li class="c-list__item">Überschwemmung aufgrund Starkregen</li>' +
      '<li class="c-list__item">Erdsenkung, Erdrutsch</li>' +
      "</ul>" +
      "</div>",
  },
  {
    modulId: "proklima",
    modulPrefix: "",
    anzeigen: true,
    aktiv: true,
    inaktivText: "",
    preisId: "VHV2024_PROKLIMA",
    name: "Pro Klima",
    nameMakler: "Pro Klima",
    icon: "icon-earth-apple",
    info:
      "Ergänzen Sie Ihren Schutz mit folgenden nachhaltigen Mehrleistungen. " +
      "<ul>" +
      "<li>Mehrkosten für energetische Modernisierung</li>" +
      "<li>Beratung durch einen Energieberater oder baubiologischen Berater</li>" +
      "<li>CO2-Kompensation nach Schadenfall</li>" +
      "<li>Zubehör der hauswirtschaftlichen Selbstversorgung (z. B. Bienenvölker, Nutztiere, Kräuter, Obst-/Gemüsepflanzen) ist mitversichert</li>" +
      "<li>Mehraufwand für Betankungskosten bei Ausfall der E-Ladestation</li>" +
      "<li>Gemeinsam mit bessergrün pflanzen wir einen Baum und fördern ökologische Projekte</li>" +
      "</ul>",
    body:
      '<div class="o-grid__cell o-grid__cell--9">' +
      '<ul class="c-list">' +
      '<li class="c-list__item">Bedienfehler &amp; technische Gefahren bei Balkonkraftwerken</li>' +
      '<li class="c-list__item">Mehrkosten bis zu 25 % für Wiederbeschaffung und -herstellung mit ökologischem Mehrwert</li>' +
      '<li class="c-list__item">Mehrkosten für Smarthome-Aufrüstung</li>' +
      '<li class="c-list__item"><span style="display:inline-block;width:100px"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
      '\t viewBox="0 0 123 32" style="enable-background:new 0 0 123 32;" xml:space="preserve">\n' +
      '<style type="text/css">\n' +
      "\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n" +
      "\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n" +
      "\t.st2{mask:url(#mask-2_00000123422127798124330940000009443536324654673805_);fill-rule:evenodd;clip-rule:evenodd;fill:#65B22E;}\n" +
      "\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#64C8F4;}\n" +
      "\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#65B22E;}\n" +
      "</style>\n" +
      '<g id="Symbols">\n' +
      '\t<g id="BG19_Navigation-Mobile" transform="translate(-16.000000, -14.000000)">\n' +
      '\t\t<g id="BG-Logo" transform="translate(16.000000, 14.000000)">\n' +
      '\t\t\t<g id="Group-13-Copy">\n' +
      '\t\t\t\t<g id="Group-6" transform="translate(74.215910, 14.243609)">\n' +
      '\t\t\t\t\t<g id="Clip-5">\n' +
      "\t\t\t\t\t</g>\n" +
      "\t\t\t\t\t<defs>\n" +
      '\t\t\t\t\t\t<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0.1" y="0" width="48.3" height="16.8">\n' +
      '\t\t\t\t\t\t\t<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>\n' +
      "\t\t\t\t\t\t</filter>\n" +
      "\t\t\t\t\t</defs>\n" +
      "\t\t\t\t\t\n" +
      '\t\t\t\t\t\t<mask maskUnits="userSpaceOnUse" x="0.1" y="0" width="48.3" height="16.8" id="mask-2_00000123422127798124330940000009443536324654673805_">\n' +
      '\t\t\t\t\t\t<g class="st0">\n' +
      '\t\t\t\t\t\t\t<polygon id="path-1_00000170963098101397575370000018042284489795726781_" class="st1" points="0.1,0 48.4,0 48.4,16.9 \n' +
      '\t\t\t\t\t\t\t\t0.1,16.9 \t\t\t\t\t\t\t"/>\n' +
      "\t\t\t\t\t\t</g>\n" +
      "\t\t\t\t\t</mask>\n" +
      '\t\t\t\t\t<path id="Fill-4" class="st2" d="M4.2,3.5C3.8,4.1,3.5,5,3.5,6.2c0,1.1,0.3,2,0.7,2.6c0.5,0.6,1.1,0.9,1.9,0.9\n' +
      "\t\t\t\t\t\tc0.5,0,0.9-0.1,1.3-0.4c0.4-0.2,0.7-0.6,1-1.1C8.7,7.6,8.9,7,8.9,6.3c0-1.2-0.3-2.1-0.8-2.7C7.6,3,7,2.7,6.1,2.7\n" +
      "\t\t\t\t\t\tC5.3,2.7,4.7,2.9,4.2,3.5z M16.2,12.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.5V2.2c0-1.8,0.9-2.2,1.7-2.2\n" +
      "\t\t\t\t\t\tc0.6,0,1,0.2,1.2,0.6c0.2,0.2,0.3,0.5,0.3,0.9c0.3-0.4,0.5-0.7,0.8-0.9C19,0.2,19.5,0,20.2,0c0.7,0,1.3,0.2,1.9,0.5\n" +
      "\t\t\t\t\t\tc0.7,0.3,1,0.8,1,1.4c0,0.4-0.1,0.8-0.4,1c-0.3,0.3-0.6,0.4-1,0.4c-0.1,0-0.3,0-0.9-0.2c-0.9-0.3-1.6-0.2-2,0.1\n" +
      "\t\t\t\t\t\tc-0.2,0.2-0.4,0.5-0.6,0.9c-0.1,0.4-0.3,1-0.3,1.6v0c-0.1,0.6-0.1,1.4-0.1,2.2v2.5c0,0.7-0.2,1.2-0.5,1.5\n" +
      "\t\t\t\t\t\tC17.1,12.3,16.7,12.5,16.2,12.5L16.2,12.5z M33.2,12.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.4-0.7-0.4-1.2\n" +
      "\t\t\t\t\t\tc-0.3,0.3-0.5,0.5-0.8,0.7c-0.4,0.3-0.9,0.6-1.4,0.7c-0.5,0.2-1,0.2-1.7,0.2c-0.8,0-1.4-0.2-2-0.5c-0.6-0.3-1.1-0.8-1.4-1.3\n" +
      "\t\t\t\t\t\tc-0.4-0.7-0.6-1.6-0.6-2.8V2c0-0.6,0.2-1.1,0.5-1.5C24.5,0.2,24.9,0,25.4,0c0.5,0,0.9,0.2,1.2,0.5C27,0.9,27.1,1.4,27.1,2v4.7\n" +
      "\t\t\t\t\t\tc0,0.7,0.1,1.2,0.2,1.7c0.1,0.4,0.3,0.8,0.6,1c0.3,0.2,0.6,0.3,1.1,0.3c0.5,0,0.9-0.1,1.3-0.4c0.4-0.3,0.7-0.6,0.9-1.1\n" +
      "\t\t\t\t\t\tc0.2-0.4,0.2-1.3,0.2-2.7V2c0-0.6,0.2-1.1,0.5-1.5C32.2,0.2,32.6,0,33.1,0c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.5v8.6\n" +
      "\t\t\t\t\t\tc0,0.6-0.1,1.1-0.4,1.4C34.1,12.3,33.7,12.5,33.2,12.5L33.2,12.5z M46.7,12.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.5\n" +
      "\t\t\t\t\t\tV5.5c0-0.9-0.1-1.7-0.4-2.1c-0.2-0.4-0.7-0.7-1.5-0.7c-0.5,0-0.9,0.1-1.3,0.4c-0.4,0.3-0.7,0.7-0.9,1.2\n" +
      "\t\t\t\t\t\tc-0.1,0.4-0.2,1.2-0.2,2.4v3.7c0,0.7-0.2,1.2-0.5,1.5c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5\n" +
      "\t\t\t\t\t\tc-0.3-0.3-0.5-0.8-0.5-1.5V1.9c0-0.6,0.1-1.1,0.4-1.4C38,0.2,38.4,0,38.9,0c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.4,0.6,0.6v0\n" +
      "\t\t\t\t\t\tc0.1,0.2,0.2,0.5,0.2,0.8C41,1.2,41.4,0.8,42,0.5C42.6,0.2,43.4,0,44.2,0c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.2,0.9,1.5,1.5\n" +
      "\t\t\t\t\t\tc0.2,0.4,0.3,0.8,0.4,1.2c0.1,0.4,0.1,1,0.1,1.6v5.5c0,0.6-0.2,1.1-0.5,1.5C47.6,12.3,47.2,12.5,46.7,12.5L46.7,12.5z M6,16.9\n" +
      "\t\t\t\t\t\tc-1.1,0-2-0.1-2.8-0.4c-0.8-0.3-1.5-0.7-2-1.2c-0.5-0.5-0.7-1-0.7-1.5c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.6-0.4,1-0.4\n" +
      "\t\t\t\t\t\tc0.5,0,0.9,0.2,1.3,0.6c0.2,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.1,1,0.1\n" +
      "\t\t\t\t\t\tc0.7,0,1.3-0.1,1.7-0.3c0.4-0.2,0.7-0.5,0.8-0.8c0.2-0.4,0.3-0.8,0.3-1.2c0-0.3,0-0.8,0.1-1.5c-0.4,0.4-0.8,0.8-1.3,1\n" +
      "\t\t\t\t\t\tc-0.6,0.3-1.4,0.5-2.3,0.5c-1,0-2-0.3-2.7-0.8c-0.8-0.5-1.4-1.3-1.8-2.2C0.3,8.3,0.1,7.2,0.1,6c0-0.9,0.1-1.7,0.4-2.5\n" +
      "\t\t\t\t\t\tc0.3-0.7,0.6-1.4,1.1-1.9c0.5-0.5,1-0.9,1.6-1.2c0.6-0.3,1.3-0.4,2-0.4c0.9,0,1.7,0.2,2.3,0.5C8,0.8,8.5,1.2,9,1.7\n" +
      "\t\t\t\t\t\tc0-0.5,0.2-0.9,0.4-1.2C9.7,0.2,10.1,0,10.6,0c0.7,0,1.1,0.2,1.3,0.7v0c0.2,0.4,0.3,1,0.3,1.7V11c0,1-0.1,1.9-0.3,2.6\n" +
      '\t\t\t\t\t\tc-0.2,0.7-0.6,1.4-1.1,1.8c-0.5,0.5-1.1,0.8-1.9,1.1C8.1,16.8,7.1,16.9,6,16.9L6,16.9z"/>\n' +
      "\t\t\t\t</g>\n" +
      '\t\t\t\t<path id="Fill-7" class="st3" d="M17.1,19.3h5c-0.1-0.9-0.3-1.5-0.8-1.9c-0.4-0.5-1-0.7-1.8-0.7c-0.7,0-1.3,0.2-1.7,0.7h0\n' +
      "\t\t\t\t\tC17.5,17.8,17.3,18.5,17.1,19.3 M55.1,19.3h5c-0.1-0.9-0.3-1.5-0.8-1.9c-0.4-0.5-1-0.7-1.8-0.7c-0.7,0-1.3,0.2-1.7,0.7\n" +
      "\t\t\t\t\tC55.5,17.8,55.2,18.5,55.1,19.3 M6.2,16.8c-0.5,0-1,0.1-1.4,0.4c-0.4,0.3-0.7,0.7-1,1.3c-0.2,0.6-0.4,1.2-0.4,2\n" +
      "\t\t\t\t\tc0,1.1,0.3,2,0.8,2.6c0.5,0.6,1.2,0.9,2,0.9c0.7,0,1.3-0.3,1.8-0.9c0.5-0.6,0.8-1.5,0.8-2.7c0-0.8-0.1-1.4-0.3-2\n" +
      "\t\t\t\t\tc-0.2-0.5-0.5-0.9-0.9-1.2C7.1,17,6.7,16.8,6.2,16.8 M6.9,26.7c-0.5,0-0.9-0.1-1.4-0.2c-0.4-0.1-0.8-0.3-1.1-0.5\n" +
      "\t\t\t\t\tc-0.3-0.2-0.6-0.4-0.8-0.6c-0.1-0.1-0.3-0.3-0.5-0.5c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5\n" +
      "\t\t\t\t\tC0.1,25.9,0,25.4,0,24.8v-13c0-0.6,0.1-1.1,0.4-1.5C0.7,10,1.1,9.8,1.6,9.8c0.5,0,0.9,0.2,1.2,0.5v0c0.3,0.3,0.4,0.8,0.4,1.4\n" +
      "\t\t\t\t\tv4.1c0.5-0.4,0.9-0.8,1.4-1c0.6-0.3,1.4-0.5,2.3-0.5c1,0,2,0.2,2.7,0.7c0.8,0.5,1.4,1.2,1.8,2.1c0.4,0.9,0.6,2,0.6,3.2\n" +
      "\t\t\t\t\tc0,0.9-0.1,1.8-0.4,2.5c-0.2,0.8-0.6,1.5-1,2c-0.5,0.6-1,1-1.7,1.3C8.5,26.5,7.7,26.7,6.9,26.7 M20,26.7c-2,0-3.6-0.6-4.7-1.7\n" +
      "\t\t\t\t\tc-1.1-1.1-1.7-2.7-1.7-4.6c0-0.9,0.1-1.7,0.4-2.5c0.3-0.8,0.7-1.4,1.2-2c0.5-0.6,1.2-1,2-1.3c0.8-0.3,1.6-0.4,2.5-0.4\n" +
      "\t\t\t\t\tc1.2,0,2.3,0.3,3.1,0.8c0.9,0.5,1.5,1.2,2,2c0.4,0.8,0.7,1.6,0.7,2.5c0,0.8-0.3,1.4-0.8,1.6h0c-0.5,0.2-1.1,0.4-1.9,0.4h-5.7\n" +
      "\t\t\t\t\tc0,0.6,0.2,1.1,0.4,1.5c0.2,0.5,0.6,0.8,1,1.1c0.4,0.2,0.9,0.4,1.4,0.4c0.3,0,0.7,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4\n" +
      "\t\t\t\t\tc0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.5-0.5,0.9-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.4,0.5,0.4,0.9\n" +
      "\t\t\t\t\tc0,0.3-0.1,0.6-0.3,1c-0.2,0.4-0.6,0.7-1,1.1c-0.4,0.3-1,0.6-1.7,0.9C21.6,26.6,20.8,26.7,20,26.7 M32.2,26.7\n" +
      "\t\t\t\t\tc-1.1,0-2.1-0.2-2.9-0.5c-0.8-0.3-1.4-0.8-1.8-1.3c-0.4-0.5-0.6-1.1-0.6-1.6c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4\n" +
      "\t\t\t\t\tc0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.4,0.4,0.5,0.7c0.3,0.5,0.6,0.9,1,1.1c0.4,0.2,1,0.4,1.7,0.4c0.6,0,1-0.1,1.4-0.4\n" +
      "\t\t\t\t\tc0.3-0.2,0.5-0.5,0.5-0.7c0-0.5-0.2-0.8-0.5-1c-0.4-0.2-1-0.5-1.9-0.7c-1-0.3-1.9-0.5-2.6-0.8c-0.7-0.3-1.2-0.7-1.6-1.2\n" +
      "\t\t\t\t\tc-0.4-0.5-0.6-1.1-0.6-1.8c0-0.6,0.2-1.2,0.6-1.8c0.4-0.6,0.9-1,1.7-1.3c0.7-0.3,1.6-0.5,2.6-0.5c0.8,0,1.5,0.1,2.2,0.2\n" +
      "\t\t\t\t\tc0.6,0.2,1.2,0.4,1.6,0.7c0.4,0.3,0.8,0.6,1,1c0.2,0.4,0.4,0.7,0.4,1.1c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.7,0.4-1.1,0.4\n" +
      "\t\t\t\t\tc-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.5-0.5-0.8-0.8c-0.2-0.3-0.5-0.5-0.7-0.6c-0.3-0.2-0.7-0.2-1.2-0.2c-0.5,0-0.9,0.1-1.2,0.3\n" +
      "\t\t\t\t\tc-0.3,0.2-0.4,0.4-0.4,0.7c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.6,0.3,1,0.5c0.4,0.1,1.1,0.3,1.8,0.5c0.9,0.2,1.7,0.5,2.3,0.8\n" +
      "\t\t\t\t\tc0.6,0.3,1.1,0.7,1.4,1.2c0.3,0.5,0.5,1,0.5,1.6c0,0.9-0.2,1.6-0.6,2.2c-0.4,0.6-1.1,1.1-1.9,1.4C34.4,26.6,33.4,26.7,32.2,26.7\n" +
      "\t\t\t\t\t M44.5,26.7c-1.1,0-2.1-0.2-2.9-0.5c-0.8-0.3-1.4-0.8-1.8-1.3c-0.4-0.5-0.6-1.1-0.6-1.6c0-0.4,0.1-0.7,0.4-1\n" +
      "\t\t\t\t\tc0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.4,0.4,0.5,0.7c0.3,0.5,0.6,0.9,1,1.1c0.4,0.2,1,0.4,1.7,0.4\n" +
      "\t\t\t\t\tc0.6,0,1-0.1,1.4-0.4c0.3-0.2,0.5-0.5,0.5-0.7c0-0.5-0.2-0.8-0.5-1c-0.4-0.2-1-0.5-1.9-0.7c-1-0.3-1.9-0.5-2.6-0.8\n" +
      "\t\t\t\t\tc-0.7-0.3-1.2-0.7-1.6-1.2c-0.4-0.5-0.6-1.1-0.6-1.8c0-0.6,0.2-1.2,0.6-1.8c0.4-0.6,0.9-1,1.7-1.3c0.7-0.3,1.6-0.5,2.6-0.5\n" +
      "\t\t\t\t\tc0.8,0,1.5,0.1,2.2,0.2c0.6,0.2,1.2,0.4,1.6,0.7c0.4,0.3,0.8,0.6,1,1c0.2,0.4,0.4,0.7,0.4,1.1c0,0.4-0.1,0.7-0.4,1\n" +
      "\t\t\t\t\tc-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.5-0.5-0.8-0.8c-0.2-0.3-0.5-0.5-0.7-0.6c-0.3-0.2-0.7-0.2-1.2-0.2\n" +
      "\t\t\t\t\tc-0.5,0-0.9,0.1-1.2,0.3c-0.3,0.2-0.4,0.4-0.4,0.7c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.6,0.3,1,0.5c0.4,0.1,1.1,0.3,1.8,0.5\n" +
      "\t\t\t\t\tc0.9,0.2,1.7,0.5,2.3,0.8c0.6,0.3,1.1,0.7,1.4,1.2c0.3,0.5,0.5,1,0.5,1.6c0,0.9-0.2,1.6-0.6,2.2c-0.4,0.6-1.1,1.1-1.9,1.4\n" +
      "\t\t\t\t\tC46.6,26.6,45.6,26.7,44.5,26.7 M57.9,26.7c-2,0-3.6-0.6-4.7-1.7c-1.1-1.1-1.7-2.7-1.7-4.6c0-0.9,0.1-1.7,0.4-2.5\n" +
      "\t\t\t\t\tc0.3-0.8,0.7-1.4,1.2-2c0.5-0.6,1.2-1,2-1.3c0.8-0.3,1.6-0.4,2.5-0.4c1.2,0,2.3,0.3,3.1,0.8c0.9,0.5,1.5,1.2,2,2\n" +
      "\t\t\t\t\tc0.4,0.8,0.7,1.6,0.7,2.5c0,0.8-0.3,1.4-0.8,1.6c-0.5,0.2-1.1,0.4-1.9,0.4h-5.7c0,0.6,0.2,1.1,0.4,1.5c0.2,0.5,0.6,0.8,1,1.1\n" +
      "\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.4c0.3,0,0.7,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.5-0.5,0.9-0.8\n" +
      "\t\t\t\t\tc0.2-0.2,0.5-0.3,0.8-0.3c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.6-0.3,1c-0.2,0.4-0.6,0.7-1,1.1\n" +
      "\t\t\t\t\tc-0.4,0.3-1,0.6-1.7,0.9C59.5,26.6,58.8,26.7,57.9,26.7 M67.2,26.7c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.5v-8.3\n" +
      "\t\t\t\t\tc0-1.8,0.9-2.2,1.7-2.2c0.6,0,1,0.2,1.3,0.6c0.2,0.2,0.3,0.5,0.3,0.9c0.3-0.4,0.6-0.7,0.8-0.9c0.4-0.3,1-0.5,1.7-0.5\n" +
      "\t\t\t\t\tc0.7,0,1.3,0.2,1.9,0.5c0.7,0.3,1,0.8,1,1.4c0,0.4-0.1,0.8-0.4,1c-0.3,0.3-0.6,0.4-1,0.4c-0.1,0-0.3,0-0.9-0.2\n" +
      "\t\t\t\t\tc-0.9-0.3-1.6-0.2-2,0.1c-0.2,0.2-0.4,0.5-0.6,0.9c-0.1,0.4-0.3,1-0.3,1.6c-0.1,0.6-0.1,1.4-0.1,2.3v2.5c0,0.7-0.2,1.2-0.5,1.5\n" +
      '\t\t\t\t\tC68.1,26.5,67.7,26.7,67.2,26.7"/>\n' +
      '\t\t\t\t<path id="Fill-9" class="st4" d="M109.4,11.9c2.3-1.9,3.5-5.7,3.5-7.4c-0.2,0.1-0.4,0.3-0.7,0.4c-0.8,0.4-2,0.4-3,0.3\n' +
      "\t\t\t\t\tc-0.6,0-1.1-0.1-1.5,0c-1,0.3-3.4,1.3-3.3,5.5c1.2,0.7,2.3,0.8,3.4,0.3c2.3-1,3.6-4.4,3.7-4.9c0-0.2,0.1-0.3,0.3-0.3\n" +
      '\t\t\t\t\tc0.2,0,0.3,0.1,0.3,0.3c0,0.3-1.2,3.7-3.5,5.2c-1.2,0.7-2.4,0.9-3.7,0.3l-0.6,0.5C106.2,13.2,107.9,13.1,109.4,11.9"/>\n' +
      '\t\t\t\t<path id="Fill-11" class="st4" d="M99.5,12.9c0,0-0.1,0-0.1,0c-2.3-0.8-3.5-2.4-3.6-4.5c-0.1-3.5,2.9-7.6,4.5-8.3\n' +
      "\t\t\t\t\tc0.1-0.1,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4c0,0-0.1,0.3,0.1,1.1c0.2,0.7,0.9,1.5,1.6,2.1c0.5,0.5,0.9,0.9,1,1.3\n" +
      "\t\t\t\t\tc0.2,0.5,0.6,1.4,0.4,2.7c-0.2,1.5-1.2,2.9-3,4.2c-0.1,0.1-0.2,0.1-0.3,0.1c-1.9-0.6-3-1.7-3.2-3.4c-0.4-2.7,1.5-5.8,1.8-5.9\n" +
      "\t\t\t\t\tc0.2-0.1,0.4-0.1,0.5,0.1c0.1,0.1,0.1,0.3,0,0.4c-0.3,0.4-2.2,3.5-1.4,5.8c0.3,1.1,1.2,1.8,2.5,2.3c3.4-2.6,2.7-5,2.2-5.9\n" +
      "\t\t\t\t\tc-0.1-0.3-0.5-0.7-0.9-1.1c-0.7-0.7-1.5-1.6-1.7-2.4c-0.1-0.3-0.1-0.6-0.1-0.8c-1.4,1.1-3.7,4.5-3.6,7.4\n" +
      '\t\t\t\t\tc0.1,1.9,1.1,3.2,3.2,3.9c0.2,0.1,0.3,0.2,0.2,0.4C99.8,12.8,99.7,12.9,99.5,12.9"/>\n' +
      "\t\t\t</g>\n" +
      "\t\t</g>\n" +
      "\t</g>\n" +
      "</g>\n" +
      "</svg></span></li>" +
      "</ul>" +
      "</div>",
  },
  {
    modulId: "soforthilfe",
    modulPrefix: "Serviceleistung",
    anzeigen: true,
    aktiv: true,
    inaktivText: "",
    preisId: "VHV2024_SOFORTHILFE",
    name: "Soforthilfe",
    nameMakler: "Soforthilfe",
    icon: "icon-heart-mobile",
    info:
      "Ergänzt Ihren persönlichen Schutz um wertvolle Leistungen:" +
      "<ul>" +
      "<li>Notfallservice bei Schlüsselverlust, Heizungsausfall, Sanitärproblemen</li>" +
      "<li>Handwerkerservice für Sanitär- und Elektro-Installationen</li>" +
      "<li>Beteiligung an den Kosten für Schädlingsbekämpfungen und die fachgerechte Entfernung von Wespen- und Hornissen-Nestern</li>" +
      "<li>Organisation der Kinderbetreuung oder die Rückreise bzw. den Reiseabbruch bei entstandenen Schäden zu Hause</li>" +
      "<li>Organisation einer psychologischer Erstberatung bei Raub oder Einbruchdiebstahl</li>" +
      "</ul>",
    body:
      '<div class="o-grid__cell o-grid__cell--9">' +
      '<ul class="c-list">' +
      '<li class="c-list__item">Schlüsselverlust, Heizungsausfall</li>' +
      '<li class="c-list__item">Sanitärprobleme</li>' +
      "</ul>" +
      "</div>",
  },
];
